<script lang="ts">
  import { onMount } from "svelte";
  import { initFilesList, records, downloadSampleFile } from "./task-file.store";
  import { ChallengePage } from "./challenge-tab";
  import TaskSubmissionLayout from "./TaskSubmissionLayout.svelte";

  export let sectionId: number;
  export let challengeId: number;

  function onSampleFileClick(taskId: number, fileType: string, fileName: string) {
    downloadSampleFile(taskId, fileType, fileName);
  }

  onMount(() => initFilesList(sectionId, challengeId));
</script>

<TaskSubmissionLayout {sectionId} {challengeId} currentTab={ChallengePage.Files}>
  <div class="content box">
    <h2 class="subtitle">Sample Files</h2>

    {#if $records.length == 0}
      <div class="has-text-centered">
        <h2 class="subtitle">There are no sample files in this challenge</h2>
      </div>
    {:else}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <!-- svelte-ignore a11y-no-static-element-interactions -->
      <div class="sample-file-container">
        {#each $records as file}
          <div class="file-section noselect clickable" on:click={(_) => onSampleFileClick(file.challengeTaskId, file.fileType, file.fileName)}>
            <i class="material-icons icon-base">description</i>
            <span class="sample-file-name">{file.fileName}</span>
          </div>
        {/each}
      </div>
    {/if}
  </div>
</TaskSubmissionLayout>

<style>
  .sample-file-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .file-section {
    display: inline-flex;
    /*min-width: 30rem;
    width: 10rem;
    */
    margin-right: 4rem;
    margin-bottom: 2rem;
    /*background-color: #fafafa;*/
  }

  .file-section .sample-file-name {
    display: inline-block;
    margin-left: 0.25rem;
    font-size: larger;
  }

  .file-section:hover .sample-file-name {
    text-decoration: underline;
  }

  .clickable {
    cursor: pointer !important;
  }
</style>
